/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// material
import {
  Stack,
  Typography,
  Box,
  LinearProgress,
  Backdrop,
  CircularProgress,
  TextField,
  alpha,
  Menu,
  styled,
  useMediaQuery,
  Container,
} from '@mui/material';
// components
import { doc, updateDoc } from 'firebase/firestore';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import { db } from '../../../firebase.config';
import CustomButton from '../../../components/CustomButton';
import { useSnackbar } from '../../../context/snackbarContext';
import CustomModal from '../../../components/customModal/customModal';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 7,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

export default function OwnSite() {
  const { eventID } = useParams();
  const navigate = useNavigate()
  const showSnackbar = useSnackbar()
  // loading
  const [loading, setLoading] = React.useState(false);

  // for change value of globla quota
  const [open, setOpen] = React.useState(false);
  const [refreh, setRefresh] = React.useState(false);
  const [customIndex, setCustom] = useState(0);
  const [embedParams, setEmbedParams] = useState('');
  const [colors, setColors] = useState({ bg: "", primaire: "#5E17EB", secondaire: "" });
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    console.log(event.currentTarget);
    setAnchorEl(event.currentTarget);
    if (event.target.id === 'bt-fdColor') {
      setCustom(1)
    } else if (event.target.id === 'bt-primaire') {
      setCustom(2)
    } else if (event.target.id === 'bt-secondaire') {
      setCustom(3)
    }
  };


  const [url, setUrl] = useState('');
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setUrl(`http://localhost:3001/fr/event_embed/${eventID}/${embedParams}`);
        // setUrl(`https://choptonticket.com/fr/event_embed/${eventID}/${embedParams}`);
        console.log(`http://localhost:3001/fr/event_embed/${eventID}/${embedParams}`);
        setLoading(false);
      } catch (error) {
        console.log('error');
      }
    })();
  }, [refreh, embedParams]);


  const isMobile = useMediaQuery('(max-width:600px)');
  const handleCopy = () => {
    navigator.clipboard.writeText(`<iframe width="100%" height="100%" src="${url}" title="Billetterie Choptonticket" frameBorder={0} />`)
    showSnackbar('Texte copié dans le presse-papie', false)

  };
  const [interactive, setInteractive] = useState(false);

  return (
    <Page title="Widget de vente" >
      {loading && <LinearProgress />}


      <Container sx={{ marginTop: { xs: 3 } }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'start', sm: 'center' }}
          justifyContent="space-between"
          mb={5}
          spacing={2}
        >
          <Typography variant="h3" gutterBottom>
            Widget de vente <br />
            <Typography variant="body2">
              Obtenez le code d'intégration du module de vente
            </Typography>
          </Typography>
        </Stack>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
        >
          <Stack spacing={2} padding={3} sx={{ bgcolor: '#daccff', borderRadius: '10px' }}>
            <Box>
              <Typography variant='h4'>Intégration dans une page HTML !</Typography>
              <Typography variant='body2'>ntégrez votre module billetterie directement dans la page HTML de votre site à l'endroit souhaité.</Typography>
            </Box>
            <Stack spacing={1} sx={{ borderRadius: '10px' }}>
              <Box>
                <Stack direction='row' alignItems='center' justifyContent='end'>
                  <Stack onClick={handleCopy} alignItems='center' direction='row' sx={{ color: 'white', cursor: 'pointer', borderRadius: '50px', bgcolor: '#5E17EB', paddingX: 2, paddingY: 1 }} spacing={1}>
                    <Iconify icon='bi:copy' />
                    <Typography variant='caption'>Copier</Typography>
                  </Stack>
                </Stack>
              </Box>
              <Box sx={{ borderRadius: '7px', bgcolor: '#D2C2FF' }} dir="ltr">
                <Typography>
                  <TextField
                    disabled
                    sx={{ borderRadius: '7px' }}
                    minRows={2}
                    multiline
                    fullWidth
                    value={`<iframe width="100%" height="500" src="${url}" title="Billetterie Choptonticket" frameBorder={0} />`}
                  />
                </Typography>
              </Box>
              <Typography variant='caption'>
                Copiez et collez ce code à l’endroit où vous souhaitez que le widget apparaisse sur votre page Web
              </Typography>
            </Stack>
            <Stack spacing={1} sx={{  justifyContent: 'center', alignItems: 'center' }}>
              <CustomButton fullWidth type='primaire' buttonText='Personaliser votre widget' onClick={() => { navigate(`/custom-widget/${eventID}`) }} />
                {
                  isMobile && <CustomButton fullWidth type='secondaire' buttonText='previsuliser votre widget' onClick={() => { setOpen(true) }} />
                }
                <CustomModal open={open} title={'Widget de vente'} showConfirm={false} cancelText='Fermer' onClose={() => {setOpen(false)}}>
<iframe width="100%" height="450" src={url} title="Billetterie Choptonticket" frameBorder={0} style={{
               pointerEvents: interactive ? 'auto' : 'none',
              borderRadius: '10px',
              border: '1px solid #f2f2f2'
            }} />
                </CustomModal>
            </Stack>

          </Stack>
          {
            !isMobile && <Box sx={{ border: '0px solid #f2f2f2', borderRadius: '10px' }}>
            <iframe width="600" height="650" src={url} title="Billetterie Choptonticket" frameBorder={0} style={{
              pointerEvents: interactive ? 'auto' : 'none',
              borderRadius: '10px',
              border: '1px solid #f2f2f2'
            }} />
          </Box>
          }
          
        </Stack>
      </Container>


    </Page>
  );
}
